import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonType } from '../../enum/button-type.enum';
import { MatDialogRef } from '@angular/material/dialog';
import { CheckboxComponent } from '../../interactive-labels/checkbox/checkbox.component';

@Component({
  selector: 'lib-optional-confirmation-dialog',
  imports: [ButtonComponent, DialogHeaderComponent, ReactiveFormsModule, CheckboxComponent],
  templateUrl: './optional-confirmation-dialog.component.html',
  styleUrl: './optional-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionalConfirmationDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<OptionalConfirmationDialogComponent>);

  protected readonly isOptional = signal(false);
  protected readonly ButtonType = ButtonType;

  public readonly config = signal<OptionalConfirmationDialogConfig | null>(null);

  primaryButtonClicked() {
    this.dialogRef.close({ result: true, isOptional: this.isOptional() });
  }

  secondaryButtonClicked() {
    this.dialogRef.close({ result: false, isOptional: this.isOptional() });
  }

  closeClicked() {
    this.dialogRef.close({ result: undefined, isOptional: this.isOptional() });
  }

  optionalCheckboxClicked() {
    this.isOptional.update(value => !value);
  }
}

export interface OptionalConfirmationDialogConfig {
  title: string;
  message: string;
  extraMessages?: string[];
  primaryButtonText: string;
  secondaryButtonText: string;
}
